/* eslint-disable no-console */

const IMAGES_URL = '/images';
const AUDIOS_URL = '/audios';
const CACHE_NAME = 'lantern-cache-v2';
const OFFLINE_TIMEOUT_DELAY = 20000;

const PING = process.env.NODE_ENV === 'development' ? '/ping.html' : './ping.html';

const SERVICE_WORKER = process.env.NODE_ENV === 'development' ? '/service-worker.js' : '/student-assessment/service-worker.js';

export const clearCDNCachedContent = () => {
    caches.open(CACHE_NAME).then(cache => {
        cache.keys().then(cacheKeys => {
            cacheKeys.forEach(request => {
                if (request.url.includes(IMAGES_URL) || request.url.includes(AUDIOS_URL)) {
                    cache.delete(request);
                }
            });
        });
    });

    return Promise.resolve();
};

export const registerServiceWorker = async () => {
    if ('serviceWorker' in navigator) {
        try {
            const reg = await navigator.serviceWorker.register(SERVICE_WORKER);
            // registration worked
            console.log(`Registration succeeded. Scope is ${reg.scope}`);
            reg.onupdatefound = () => {
                const installingWorker = reg.installing;
                if (installingWorker == null) {
                    return;
                }
                installingWorker.onstatechange = () => {
                    if (installingWorker.state === 'installed') {
                        if (navigator.serviceWorker.controller) {
                            installingWorker.postMessage({ type: 'SKIP_WAITING' });
                        }
                    }
                };
            };
            navigator.serviceWorker.addEventListener('controllerchange', () => {
                // There are certain restrictions imposed by the SEB server on page updates.
                // Specifically, we cannot refresh the page to allow a new service worker to take control
                // until the authorization process is complete.
                // Premature page updates may result in a double-authorization error.
                // To address this, we have implemented a mechanism to wait
                // until the authorization process is finalized and the core data is loaded.
                sessionStorage.setItem('reload_page', true);
            });
            return reg;
        } catch(error) {
            // registration failed
            console.log(`Registration failed with ${error}`);
        }
    } else {
        console.log('Service workers are not supported on this browser.');
    }
    return null;
};

export const getOnlineStatus = async () => {
    const controller = new AbortController();
    setTimeout(() => controller.abort(), OFFLINE_TIMEOUT_DELAY);
    const { signal } = controller;

    try {
        await fetch(PING, {
            method: 'GET',
            signal,
        });

        return true;
    } catch (e) {
        controller.abort();
    }
    return false;
};

export class OfflineError extends Error {
    constructor(message) {
        super(message);
        this.name = "OfflineError";
    }
}
